import { cn } from "@/lib/utils";

const BARS = [
  "h-16 bg-accent-on-dark/30",
  "h-28 bg-accent-on-dark/50",
  "h-40 bg-accent-on-dark/75",
  "h-52 bg-accent-on-dark",
];

interface StepBarsProps {
  className?: string;
}

/**
 * BOI's stepped-bar motif for dark (navy) surfaces. It uses the on-dark blue,
 * because the brand blue has too little contrast against the navy.
 */
export function StepBars({ className }: StepBarsProps) {
  return (
    <div aria-hidden="true" className={cn("flex items-end justify-end gap-3", className)}>
      {BARS.map((bar) => (
        <span key={bar} className={cn("w-10 rounded-sm", bar)} />
      ))}
    </div>
  );
}
